import { baseApi, client } from '../baseApi.ts';
import GetLorasResponse from '../response/GetLorasResponse.ts';

export const loraEndpoints = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getLoras: builder.query({
			// @ts-ignore
			queryFn: async () => {
				try {
					const response = await client.loras.list();
					const data = new GetLorasResponse(response?.data).formatLorasData();
					return { data };
				} catch (error) {
					return { error };
				}
			},
			providesTags: ['Loras'],
		}),
		getLoraCategories: builder.query({
			// @ts-ignore
			queryFn: async () => {
				try {
					const response = await client.loras.categories();
					return { data: response?.data };
				} catch (error) {
					return { error };
				}
			},
			providesTags: ['LoraCategories'],
		}),
	}),
});
